import {
  AddMasterResponse,
  DeletedMaster,
  LISTITEM,
  MasterError,
  MasterItem,
  MasterResponse,
  VehicleChecklistResponse,
  VehicleChecklistItem,
  AddVehicleChecklistResponse,
  ConfigurationPayload,
} from '@core/interface/configuration';
import { PagePayload } from '@core/interface/core';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const MasterActions = createActionGroup({
  source: 'Master',
  events: {
    'Load Master List': props<{ key: LISTITEM; data: ConfigurationPayload }>(),
    'Load Master List Success': props<{
      response: MasterResponse;
      key: LISTITEM;
    }>(),
    'Load Master List Failure': props<{ error: MasterError; key: LISTITEM }>(),
    'Add Edit Master': props<{ data: MasterItem; key: LISTITEM }>(),
    'Update Master Success': props<{
      response: AddMasterResponse;
      key: LISTITEM;
    }>(),
    'Update Master Failure': props<{ error: MasterError; key: LISTITEM }>(),
    'Delete Master': props<{ id: number; key: LISTITEM }>(),
    'Delete Master Success': props<{
      response: DeletedMaster;
      key: LISTITEM;
    }>(),
    'Delete Master Failure': props<{ error: MasterError; key: LISTITEM }>(),
    'Reset Master Status': props<{ key: LISTITEM }>(),
    'Reset Master List': props<{ key: LISTITEM }>(),

    'Load Dynamic Vehicle Checklist': props<PagePayload>(),
    'Load Dynamic Vehicle Checklist Success': props<VehicleChecklistResponse>(),
    'Load Dynamic Vehicle Checklist Failure': props<MasterError>(),
    'Add Edit Dynamic Vehicle Checklist': props<VehicleChecklistItem>(),
    'Add Edit Dynamic Vehicle Checklist Success':
      props<AddVehicleChecklistResponse>(),
    'Add Edit Dynamic Vehicle Checklist Failure': props<MasterError>(),
    'Reset Dynamic Vehicle Checklist': emptyProps(),
  },
});
